export class ServiceConstant {
    public static somethingWentWrongMessage = "Something was wrong";
}